"use client";

import { Container } from "@/components/ui/container";
import { Button } from "@/components/ui/button";
import CustomIcon from "@/components/ui/custom-icon";
import S from "./index.module.scss";
import { useTranslations } from "next-intl";
import { useState } from "react";
import Feedback from "@/components/entities/feedback";

const Footer = () => {
  const t = useTranslations("footer");
  const [isOpenFeedback, setIsOpenFeedback] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className={S.wrapper}>
      <Container>
        <div className={S.content}>
          <div className={S.feedback}>
            <h2 className={S.title}>{t("wantToAsk")}</h2>
            <Button onClick={() => setIsOpenFeedback(true)} arrow>
              {t("feedback")}
            </Button>
          </div>
          <div className={S.contactsWrapper}>
            <div onClick={scrollToTop} className={S.anchor}>
              <CustomIcon fileName="icon-arrow-down" className={S.anchorIcon} />
              <CustomIcon fileName="icon-to-top" className={S.anchorCircle} />
            </div>
            <div className={S.contacts}>
              <p className={S.contactsTitle}>{t("hotline")}</p>
              <a href="tel:+78002002929" className={S.contactsPhone}>
                {t("phone")}
              </a>
              <a href="mailto:info@aquaart.ru" className={S.contactsEmail}>
                {t("email")}
              </a>
            </div>
            <a href="https://vk.com/aquaart_group" rel="noreferrer" target="_blank" className={S.iconLink}>
              <CustomIcon fileName="icon-vk" />
            </a>
          </div>
        </div>
      </Container>
      <Container className={S.social}>
        <p className={S.copyright}>{t("copyright")}</p>
        <a href="https://vk.com/aquaart_group" rel="noreferrer" target="_blank" className={S.iconLink}>
          <CustomIcon fileName="icon-vk" />
        </a>
      </Container>
      {isOpenFeedback && <Feedback onClose={() => setIsOpenFeedback(false)} />}
    </footer>
  );
};

export default Footer;
